<p-toast></p-toast>
<div class="row card">
  <div class="col-sm-12">
    <form>
      <div class="row">
        <div class="col-sm-12 col-lg-6 mt-3 mb-3">
          <h5 class="" style="color: #06152b; font-weight: bold;">{{ isCreateAlertsMode ? 'Create Advanced Alerts' : 'Upload Equipment' }}</h5>
        </div>
        <div class="col-sm-12 col-lg-6 mt-2">
          <div class="float-right" style="display: flex; gap: 10px;">
            <button class="btn btn-sm btn-add-site-user text-white" *ngIf="!fromCategory && !isCreateAlertsMode" (click)="onBack()">Back</button>
            <button class="btn btn-sm btn-add-site-user text-white" *ngIf="fromCategory && !isCreateAlertsMode" (click)="onBack()">Finish Setup</button>
            <button class="btn btn-sm btn-add-site-user text-white" *ngIf="fromCategory && !isCreateAlertsMode" [disabled]="!uploadSuccessful" (click)="onCreateAlerts()">Create Alerts</button>
            <button class="btn btn-sm btn-add-site-user text-white" *ngIf="isCreateAlertsMode" (click)="onBack()">Finish Setup</button>
          </div>
        </div>
      </div>

      <div class="row mt-4" *ngIf="!isCreateAlertsMode">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <div class="card border-primary">
                    <div class="card-body" style="text-align: center;">
                      <div *ngIf="!uploadSuccessful">
                        <h6 class="card-title">Upload Equipment</h6>
                        <p class="card-text">upload equipment data for your category in order to configure the alerts</p>
                        
                        <div *ngIf="!selectedFile && !isProcessingFile" class="mb-3">
                          <button class="btn btn-primary btn-sm" (click)="fileInput.click()">
                            <i class="fa fa-upload"></i> Upload Equipment
                          </button>
                          <input 
                            #fileInput
                            type="file" 
                            accept=".xlsx,.xls" 
                            style="display: none;"
                            (change)="onFileSelected($event)"
                          />
                        </div>
                        
                        <div *ngIf="isProcessingFile" class="mb-3">
                          <div class="d-flex align-items-center justify-content-center">
                            <i class="fa fa-spinner fa-spin me-2"></i>
                            <span>Processing file...</span>
                          </div>
                        </div>
                        
                        <div *ngIf="selectedFile && !isProcessingFile" class="mb-3">
                          <div class="mb-3">
                            <label class="form-label" style="text-align: center; display: block;">Selected File:</label>
                            <div class="d-flex align-items-center justify-content-center">
                              <i class="fa fa-file-excel-o text-success me-2"></i>
                              <span class="me-2">{{ selectedFile.name }}</span>
                              <button class="btn btn-xs" style="padding: 0.15rem 0.3rem; font-size: 0.75rem; background: transparent; border: none; color: #dc3545;" (click)="removeFile()">
                                <i class="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                          <div class="text-center">
                            <button 
                              class="btn btn-success btn-sm" 
                              [class.btn-loading]="isUploading"
                              [disabled]="isUploading"
                              (click)="onSubmitFile()">
                              <span *ngIf="!isUploading">
                                <i class="fa fa-check"></i> Submit
                              </span>
                              <span *ngIf="isUploading">
                                <i class="fa fa-spinner fa-spin"></i> Uploading...
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      
                      <div *ngIf="uploadSuccessful" class="mb-3">
                        <img src="./assets/images/uploaded_successfully.png" alt="Success" style="max-width: 150px; margin-bottom: 15px;" />
                        <h6 class="card-title" style="color: #28a745;">
                          <i class="fa fa-check-circle me-2"></i>Successfully Uploaded !
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row mt-4" *ngIf="isCreateAlertsMode">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <app-create-alert [fromCategory]="fromCategory" [categoryId]="categoryId"></app-create-alert>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

